import { useSite } from "@/context/SiteContext";
import { mediaUrl } from "@/lib/api";

export default function AboutPage() {
  const { settings } = useSite();
  return (
    <div className="pt-32 md:pt-40 min-h-screen">
      <div className="max-w-[820px] mx-auto px-5 md:px-10">
        <p className="kicker text-sunset-accent mb-4">Sobre Nosotros</p>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-[0.98] mb-10">{settings.site_name || "Sunset Magazine RD"}</h1>
        <div className="article-body">
          <p>{settings.description || "Somos una revista digital premium dedicada a celebrar la cultura, los viajes, la gastronomía y el estilo de vida del Caribe y el mundo."}</p>
          <p>Creemos en el poder de la fotografía, la palabra escrita y el diseño para contar historias que perduran. Cada edición es una invitación a descubrir, explorar y sentir.</p>
          <blockquote>El verdadero lujo está en las historias que nos transforman.</blockquote>
          <h2>Nuestra Misión</h2>
          <p>Documentar y celebrar lo extraordinario de la vida contemporánea, desde los destinos más exclusivos hasta los protagonistas que definen nuestra época.</p>
          <h2>Contacto</h2>
          <p>Escríbenos a <a href={`mailto:${settings.email || "hola@sunsetmagazine.do"}`}>{settings.email || "hola@sunsetmagazine.do"}</a>{settings.phone ? ` o llámanos al ${settings.phone}.` : "."}</p>
        </div>
      </div>
    </div>
  );
}
